import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-add-number-dialog',
  templateUrl: './add-number-dialog.component.html',
  styleUrls: ['./add-number-dialog.component.scss']
})
export class AddNumberDialogComponent implements OnInit {
  showSpinner = false;
  phoneNumberToAdd = new FormGroup({
    phoneNumber: new FormControl('', [Validators.required, Validators.pattern(/^\+[1-9]{1}[0-9]{3,14}$/)]),
    description: new FormControl('')
  });
  phoneNumberListOld = [];
  phoneNumberList: any[] = [];
  tableData=[];
  id;
  companyData: {name:'',country:'',country_code:'', branch_code:'',id:'',numbers:[]};
  constructor(
    public dialogRef: MatDialogRef<AddNumberDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {
    this.companyData = data.companyData;
    if(this.companyData){
      this.phoneNumberListOld = this.companyData.numbers;
      this.id =this.companyData.id;
      if(this.phoneNumberListOld){
        for(let i=0;i<this.phoneNumberListOld.length;i++){
          let tdInstance;
          tdInstance={phone:this.phoneNumberListOld[i].split("/")[0] , description:this.phoneNumberListOld[i].split("/")[1]}
          this.tableData.push(tdInstance);
        }
      }
      
    }
  }

  ngOnInit(): void {
  }
  
  close(): void {
    this.dialogRef.close();
  }

  save(){
    if (this.phoneNumberToAdd.valid) {
      const phoneNumberNew = {
        ...this.phoneNumberToAdd.value,
      }
      this.phoneNumberList.push(this.phoneNumberToAdd.get('phoneNumber').value);
      if(this.phoneNumberListOld){
        this.phoneNumberListOld.push(this.phoneNumberToAdd.get('phoneNumber').value +'/'+ this.phoneNumberToAdd.get('description').value);
        this.phoneNumberList=this.phoneNumberListOld;
      }else{
        let instance = [this.phoneNumberToAdd.get('phoneNumber').value +'/'+ this.phoneNumberToAdd.get('description').value];
        this.phoneNumberListOld = instance;
      }
      let newPhoneNumberToAdd = {
        numbers: this.phoneNumberListOld,
        id: this.id
      }
      this.refreshPhoneNumber(newPhoneNumberToAdd);
    }
  }

  deleteNumber(indexNumberToDelete){
    this.phoneNumberListOld.splice(indexNumberToDelete,1);
    this.tableData.splice(indexNumberToDelete,1);
    let numberForDelete = {
      numbers: this.phoneNumberListOld,
      id: this.id
    }
    this.refreshPhoneNumber(numberForDelete);
  }

  refreshPhoneNumber(phoneNumberList){
    this.showSpinner = true;
      this._apiService.updateCompany(phoneNumberList).subscribe(res => {
        
        if (res) {
          console.log(res);
          this.phoneNumberListOld = res.numbers;
          this.showSpinner = false;
          this.phoneNumberToAdd.controls['phoneNumber'].setValue('');
          this.phoneNumberToAdd.controls['description'].setValue('');
          this.tableData = [];
          for(let i=0;i<res.numbers.length;i++){
            let tdInstance ={phone:this.phoneNumberListOld[i].split("/")[0] , description:this.phoneNumberListOld[i].split("/")[1]};
            this.tableData.push(tdInstance);
          }
        }
      },
      (error)=>{
        this.showSpinner = false;
      });
  }

}
